/**
 * APP 下载地址
 */
export const downloadUrl = {
  iphone: 'https://apps.apple.com/jp/app/id1586112456',
  android:
    'https://play.google.com/store/apps/details?id=com.hhodata.android.hhostore',
  web: 'https://www.7sgood.com',
  scheme: 'hhostore://hhostoreclient/action/navigateTo',
};

/**
 * 打开下载页类型
 */
export enum OpenType {
  SCHEME = '1', // 尝试SCHEME打开App
  APPSTORE = '2', // 默认跳转App Store
  SCHEMEANDAPPSTORE = '3', // 尝试SCHEME打开App并挑转App Store
  BLANK = '4', // 空白页跳转App Store
}

/**
 * 主题类型
 */
export enum ThemeType {
  default = '0', // 默认主题
  theme1 = '1', // 主题一【预留】
  theme2 = '2', // 主题二【预留】
}

/**
 * 来源类型
 */
export enum SourceType {
  HHO_APP = 'HHO_APP',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  TIKTOK = 'TIKTOK',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE',
}

/**
 * 媒介类型
 */
export enum MediumType {
  EDM = 'EDM', // 邮件营销 Electronic Direct Marketing
  IMC = 'IMC', // 营销传播 Integrated Marketing Communication
  MA = 'MA', // 营销广告  Marketing Advertising
  SMM = 'SMM', // 社交媒体 Social Media Marketing
}
